import React from 'react';
import { motion } from 'framer-motion';
import { Check, CreditCard, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="bg-[#0A0A0A] py-14 px-4 scroll-mt-10" data-id="element-158">
      <div className="container mx-auto max-w-6xl" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-161">
            Elegí tu plan hoy
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-162">
          {/* Plan 1: Super Combo Pro */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="bg-[#111111] border-2 border-[#1B3A5C] rounded-2xl p-8 flex flex-col relative" data-id="element-163">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-164">
              SUPER COMBO PRO
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-165">
              El sistema base para transformar tu taller.
            </p>

            <div className="mb-8" data-id="element-166">
              <span className="text-gray-500 line-through text-lg block mb-1" data-id="element-167">
                $276.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-168">
                <span className="text-4xl font-black text-white" data-id="element-169">$19.990</span>
                <span className="text-gray-400 font-medium" data-id="element-170">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-171">
              {['Tomo 1: Línea Herrero', 'Tomo 2: Línea Módena', 'Tomo 3: Línea A30', 'Tomo 4: Cortes y Cálculo', 'Tomo 5: Presupuestación', 'Tomo 6: Instalación', '6 Bonos Exclusivos', 'Acceso Inmediato', 'Actualizaciones de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-172">
                  <Check className="w-5 h-5 text-[#1B3A5C] shrink-0 mt-0.5" data-id="element-173" />
                  <span data-id="element-174">{item}</span>
                </li>)}
            </ul>

            <a href="https://solucionstore.shop/cart/45494138568895:1" className="w-full bg-[#1B3A5C] hover:bg-[#152c46] text-white font-bold text-lg py-4 px-6 rounded-xl text-center transition-colors mb-4 block" data-id="element-175">
              🔥 QUIERO ESTE PLAN →
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-176">
              <CreditCard className="w-4 h-4" data-id="element-177" />
              <span data-id="element-178">Hasta 12 cuotas sin interés</span>
            </div>
          </motion.div>

          {/* Plan 2: Completo + Pack Pro */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="bg-[#111111] border-2 border-[#D4A017] rounded-2xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(212,160,23,0.15)]" data-id="element-179">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#D4A017] text-black font-bold px-4 py-1 rounded-full text-sm tracking-wider" data-id="element-180">
              MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold text-[#D4A017] mb-2" data-id="element-181">
              COMBO COMPLETO + PACK PRO
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-182">
              Para el que quiere escalar su negocio rápido.
            </p>

            <div className="mb-8" data-id="element-183">
              <span className="text-gray-500 line-through text-lg block mb-1" data-id="element-184">
                $390.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-185">
                <span className="text-5xl font-black text-white" data-id="element-186">$27.990</span>
                <span className="text-gray-400 font-medium" data-id="element-187">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-188">
              <li className="flex items-start gap-3 text-white font-medium border-b border-gray-800 pb-4" data-id="element-189">
                <Check className="w-5 h-5 text-[#D4A017] shrink-0 mt-0.5" data-id="element-190" />
                <span data-id="element-191">Todo lo del Super Combo Pro, MÁS:</span>
              </li>
              {['Planilla Master Calc Excel (Automatizada)', 'Video tutoriales paso a paso', 'Acceso al Grupo VIP de Telegram', 'Soporte por WhatsApp (30 días)', 'Certificado de finalización'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200 font-medium" data-id="element-192">
                  <Check className="w-5 h-5 text-[#D4A017] shrink-0 mt-0.5" data-id="element-193" />
                  <span data-id="element-194">{item}</span>
                </li>)}
            </ul>

            <a href="https://solucionstore.shop/cart/45494160785599:1" className="w-full bg-[#D4A017] hover:bg-[#b58812] text-black font-black text-lg py-4 px-6 rounded-xl text-center transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,160,23,0.3)] mb-4 block" data-id="element-195">
              ⭐ QUIERO EL PACK COMPLETO →
            </a>

            <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-196">
              <CreditCard className="w-4 h-4" data-id="element-197" />
              <span data-id="element-198">Hasta 12 cuotas sin interés</span>
            </div>
          </motion.div>
        </div>

        <div className="mt-12 flex justify-center items-center gap-2 text-gray-400 text-sm" data-id="element-199">
          <ShieldCheck className="w-5 h-5 text-green-500" data-id="element-200" />
          <span data-id="element-201">Pagos 100% seguros procesados por Mercado Pago</span>
        </div>
      </div>
    </section>;
}